// @ts-check
import { css, jsx } from '@emotion/core';
import React from 'react';

import Sanitize from '@/src/shared/components/Sanitize';
import { bp, colors, space } from '@/styles';

const styles = {
  name: css`
    color: ${colors.primaryBlue};
    font-weight: bolder;
    font-size: 2.4rem;
  `,
  container: css`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    @media ${bp.sm} {
      flex-direction: row;
    }
  `,
  imageWrapper: css`
    padding-right: 0px;
    @media ${bp.sm} {
      padding-right: 16px;
    }
  `,
  image: css`
    border-radius: 50%;
    width: 150px;
    height: 150px;
    object-fit: cover;
    object-position: center;
  `,
};

/** 
 * @param {{
 *   image?: string;
 *   name?: string;
 *   title?: string;
 * }} propss
 */
const Title = ({ image, name, title }) => {
  return (
    <div css={styles.container}>
      <div css={styles.imageWrapper}>
        {image ? (
          <img
            css={styles.image}
            src={`data:image/jpeg;base64,${image}`}
            alt={`${name} Profile`}
          />
        ) : null}
      </div>
      <div css={space.m.b24}>
        {name && <Sanitize css={styles.name}>{name}</Sanitize>}
        {title && <Sanitize>{title}</Sanitize>}
      </div>
    </div>
  );
};

Title.propTypes = {};

export default Title;
